export interface MenuTreeNode {
  label: string;
  path?: string;
  children?: Array<MenuTreeNode>;
}

export default [
  {
    label: 'Dashboard',
    path: '/home/dashboard'
  },
  {
    label: 'Settings',
    children: [{
      label: 'User Settings',
      path: '/home/settings/user'
    }, {
      label: 'Users',
      path: '/home/settings/account'
    }, {
      label: 'App Settings',
      path: '/home/settings/app'
    }, {
      label: 'Api Settings',
      path: '/home/settings/api'
    }]
  }, {
    label: 'Notifications',
    path: '/home/settings/notifications'
  }, {
    label: 'Logs',
    path: '/home/settings/logs'
  }
]
